<template>
    <div class="product-gallery-mobile">
        <v-carousel :show-arrows="images.length > 1" hide-delimiters height="auto">
            <v-carousel-item v-for="(image, index) in images" :key="index">
                <v-img
                    v-if="image && image.url"
                    :src="$filters.imageUrl(image.url, 600)"
                    :title="image.title"
                    :lazy-src="$filters.srcHost('/placeholder.png')"
                    aspect-ratio="1"
                    class="bg-grey-lighten-2"
                    @click="showPhotoSwipe(index)"
                    @error="onImgError(index)"
                >
                    <template v-slot:placeholder>
                        <v-row v-show="!imgError[index]" class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey-lighten-5" />
                        </v-row>
                    </template>
                </v-img>
            </v-carousel-item>
        </v-carousel>
        <v-photo-swipe ref="photoSwipe" :items="photoSwipeItems" :photo-swipe-options="photoSwipeOptions" />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {ProductGallery} from '@/components/info/ProductGallery.vue'

    @Component
    export class ProductGalleryMobile extends ProductGallery {
        imgError = []

        onImgError(index) {
            this.imgError[index] = true
            return false
        }
    }

    export default ProductGalleryMobile
</script>
